import Action from '../Action';
import BankFormService from '../../services/BankFormService';
import { message } from 'antd';

export function fetchBanks() {
	return (dispatch) => {
		BankFormService.getBanks()
			.then((banks) => dispatch({ type: Action.FETCH_BANKS, banks: banks.data }))
			.catch((error) => message.error('Failed to fetch forms!'));
	};
}

export function fetchBankForms() {
	return (dispatch) => {
		BankFormService.get()
			.then((bankForms) => dispatch({ type: Action.FETCH_BANK_FORMS, bankForms: bankForms.data }))
			.catch((error) => message.error('Failed to fetch forms!'));
	};
}

export function addBankForm(body) {
	return (dispatch) => {
		BankFormService.add(body)
			.then((bankForm) => {
				dispatch({ type: Action.POST_BANK_FORM, bankForm: bankForm.data });
				message.success('Form Added');
			})
			.catch((error) => message.error('Failed to add form!'));
	};
}

export function updateBankForm(id, body) {
	return (dispatch) => {
		BankFormService.update(id, body)
			.then((bankForm) => {
				dispatch({ type: Action.UPDATE_BANK_FORM, bankForm: bankForm.data });
				message.success('Form Updated');
			})
			.catch((error) => message.error('Failed to edit form!'));
	};
}

export function deleteBankForm(id) {
	return (dispatch) => {
		BankFormService.delete(id)
			.then((bankForm) => {
				dispatch({ type: Action.DELETE_BANK_FORM, bankForm: bankForm.data });
				message.success('Form Deleted');
			})
			.catch((error) => message.error('Failed to delete form!'));
	};
}

export function updateBankFormStatus(id, body) {
	return (dispatch) => {
		BankFormService.updateStatus(id, body)
			.then((bankForm) => {
				dispatch({ type: Action.UPDATE_BANK_FORM_STATUS, bankForm: bankForm.data });
				message.success('Form Status Updated');
			})
			.catch((error) => message.error('Failed to edit form status!'));
	};
}

export function updateBankFormAgent(id, body) {
	return (dispatch) => {
		BankFormService.updateAgent(id, body)
			.then((bankForm) => {
				dispatch({ type: Action.UPDATE_BANK_FORM_AGENT, bankForm: bankForm.data });
				message.success('Form Agent Updated');
			})
			.catch((error) => message.error('Failed to edit form agent!'));
	};
}
